export const learningOsRoutes = Object.freeze({
  home: '/',
  onboarding: '/onboarding',
  dashboard: '/growth',
  learning: '/learning',
  learningPath: '/learning/path/:idOrSlug',
  aiLearningNode: '/learning/ai/:aiNodeId',
  learningStage: '/learning/:stageId',
  roadmap: '/learning-roadmap',
  roadmapStage: '/learning-roadmap/:stageId',
  resource: '/resource',
  resourceDetail: '/resource/:resourceId',
  exercise: '/exercise',
  explore: '/explore',
  project: '/projects',
  projectDetail: '/projects/:projectId',
  projectRoadmap: '/projects/:projectId/roadmap',
  projectLibrary: '/project-library',
  projectWorkspace: '/project-workspace',
  aiPartner: '/ai-partner',
  growth: '/growth',
  growthPlan: '/growth-plan',
  more: '/more',
  competitions: '/more/competitions',
  certificates: '/more/certificates',
  interview: '/more/interview',
  interviewRole: '/more/interview/:roleId',
  interviewPack: '/more/interview-pack',
  resume: '/more/resume',
  aiTools: '/more/ai-tools',
})

export const legacyRouteRedirects = Object.freeze({
  start: '/start',
  dashboard: '/dashboard',
  roadmap: '/roadmap',
  careerPlanner: '/career-planner',
  studentStart: '/student/start',
  studentHome: '/student',
  studentOnboarding: '/student/onboarding',
  studentDashboard: '/student/dashboard',
  studentGrowth: '/student/growth',
  studentGrowthPlan: '/student/growth-plan',
  studentResources: '/student/resources',
  studentRoadmap: '/student/roadmap',
  studentProjects: '/student/project-recommendations',
  studentCompetitions: '/student/competitions',
  studentCertificates: '/student/certificates',
  studentInterviewPack: '/student/interview-pack',
  studentResume: '/student/resume',
  resume: '/resume',
  resumeAnalyzer: '/resume-analyzer',
  interview: '/interview',
  studentAiTools: '/student/ai-tools',
  studentGrowthCompanion: '/student/growth-companion',
  studentCareerExplore: '/student/career-explore',
  studentMajorCareers: '/student/major-careers',
  studentProjectLibrary: '/student/project-library',
  studentProjectWorkspace: '/student/project-workspace',
  studentProjectDetail: '/student/projects/:projectId',
  studentProjectRoadmap: '/student/projects/:projectId/roadmap',
  studentProjectsList: '/student/projects',
  studentLearning: '/student/learning',
  studentLearningPaths: '/student/learning/paths',
  studentLearningPathDetail: '/student/learning/paths/:idOrSlug',
  studentLearningNode: '/student/learning/nodes/:idOrSlug',
})

export function learningStagePath(stageId) {
  return `/learning/${encodeURIComponent(stageId || '')}`
}

export function aiLearningNodePath(nodeId) {
  return `/learning/ai/${encodeURIComponent(nodeId || '')}`
}
